module.exports = __webpack_public_path__ + "img/softshell_dorsal_labelled.4ad8eb87.jpg";